import { MutationTree } from 'vuex';
import { SectionAccessState } from './types';
import { SingleFilter } from '@/store/types';
import { SectionAccessResource } from '@/api/requests/types';

export const mutations: MutationTree<SectionAccessState> = {

    /** Section Accesses */

    /**
     * Add a section access to the list.
     *
     * @param state
     * @param sectionAccess
     */
    addSectionAccess(state, sectionAccess: SectionAccessResource) {
        state.sectionAccesses.push(sectionAccess);
    },

    /**
     * Set the section accesses list.
     *
     * @param state
     * @param sectionAccesses
     */
    setSectionAccesses(state, sectionAccesses: SectionAccessResource[]) {
        state.sectionAccesses = sectionAccesses;
    },

    /**
     * Reset section accesses' list
     *
     * @param state
     */
    resetSectionAccesses(state) {
        state.sectionAccesses = [];
    },
    
    /** Filters */

     /**
     * Set a query filter in state.
     * @param state
     * @param key
     */
     setFilter(state, { key, value }: SingleFilter) {
        state.filters = { ...state.filters, [key]: value };
    },

    /**
     * Reset a single filter.
     *
     * @param state
     * @param key
     */
    resetFilter(state, key: string) {
        delete state.filters[key];
    },


    /**
     * Reset query filters.
     *
     * @param state
     */
    resetFilters(state) {
        state.filters = {};
    },
};
